import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { AbstractCollection } from '../../../abstract/Collection';
import type { WithFieldValue } from 'firebase/firestore';
import { Identified, PartialMaybe, Timestamped } from '../../../abstract/_';
import type { IWeddingCampaignMessage } from './Messages.types';
import { Campaign } from '../Campaigns';

@Identifiable
@Timestampable
export class CampaignMessage extends AbstractDocument<IWeddingCampaignMessage> {
  readonly collections = {};

  /**
   * Returns the parent Campaign of this Message
   */
  get campaign() {
    return this.reference.parent.parent!.id;
  }
}

export class CampaignMessages extends AbstractCollection<CampaignMessage, IWeddingCampaignMessage> {
  static path = 'messages';

  constructor(document: Campaign) {
    super(document.collection(CampaignMessages.path), CampaignMessage);
  }

  /**
   * Returns the parent Campaign of this Messages collection
   */
  get campaign() {
    return this.reference.parent!.id;
  }

  /**
   * Creates a new campaign message
   *
   * @param data Object containing campaign messages creation parameters
   */
  async create(data: WithFieldValue<PartialMaybe<IWeddingCampaignMessage, Identified & Timestamped>>): Promise<CampaignMessage> {
    return await this.push().create(data as IWeddingCampaignMessage);
  }
}
